export default __webpack_public_path__ + "static/media/sharedFrame.1119c637.png";